import React, { useEffect, useRef, forwardRef } from "react";
import dropdownStyles from "./dropdown.module.scss";
import { ReactComponent as DownArrowGrayIcon } from "../../assets/svg/DownArrowGray.svg";

const Dropdown = forwardRef(
  (
    {
      label,
      value,
      open,
      setOpen,
      dropDownValues,
      placeholder,
      dropdownContainerClass,
      handleDropdowns,
      dKey,
    },
    ref
  ) => {
    const getLIstyles = (eachListValue) => {
      if (eachListValue.name === value[dKey]) {
        return `${dropdownStyles.LIStyles} ${dropdownStyles.isListValueSelected}`;
      } else {
        return dropdownStyles.LIStyles;
      }
    };

    const handleToggleDropdown = () => {
      setOpen((prev) => !prev);
    };

    const dropdownRef = useRef(null);
    const dropdownButtonRef = useRef(null);

    const combinedRef = ref || dropdownButtonRef;

    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    const handleKeyDown = (event) => {
      if (open) {
        if (event.key === "Escape") {
          setOpen(false);
          combinedRef.current?.focus();
        } else if (event.key === "ArrowDown" || event.key === "ArrowUp") {
          event.preventDefault();
        } else if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          handleToggleDropdown();
        }
      } else {
        if (
          event.key === "Enter" ||
          event.key === " " ||
          event.key === "ArrowDown"
        ) {
          event.preventDefault();
          setOpen(true);
        }
      }
    };

    useEffect(() => {
      document.addEventListener("mousedown", handleOutsideClick);
      return () => {
        document.removeEventListener("mousedown", handleOutsideClick);
      };
    }, []);

    return (
      <div
        className={`${dropdownStyles.dropdownWrapper} ${dropdownContainerClass}`}
        ref={dropdownRef}
      >
        <p className={dropdownStyles.dropdownHeading}>{label}</p>
        <div
          ref={combinedRef}
          className={dropdownStyles.dropdownBtn}
          onClick={handleToggleDropdown}
          onKeyDown={handleKeyDown}
          tabIndex={0}
          role="combobox"
          aria-expanded={open}
          aria-haspopup="listbox"
        >
          {value[dKey] || placeholder}
          <span
            className={`${dropdownStyles.dropdownArrow} ${
              open && dropdownStyles.dropdownArrowOepn
            }`}
          >
            <DownArrowGrayIcon />
          </span>
          <div
            className={`${dropdownStyles.dropdownContent} ${
              open && dropdownStyles.dropdownContentOpen
            }`}
          >
            <ul role="listbox">
              {dropDownValues?.length > 0 &&
                dropDownValues.map((eachDropDownValue, index) => {
                  return (
                    <li
                      key={index}
                      className={getLIstyles(eachDropDownValue)}
                      onClick={() =>
                        handleDropdowns(dKey, eachDropDownValue.name)
                      }
                      role="option"
                      aria-selected={eachDropDownValue.name === value[dKey]}
                    >
                      {eachDropDownValue.name}
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      </div>
    );
  }
);

Dropdown.displayName = "Dropdown";

export default Dropdown;
